<template>
  <div class="game-loader"></div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'platform',
    ]),
  },
  watch: {
    platform(value) {
      if (value && value.channel) {
        this.$router.push({
          name: value.channel,
        });
      }
    },
  },
};
</script>

<style lang="scss">
  .game-loader {
    position: relative;
    width: 100%;
    height: 100%;
  }
</style>
